const about = () => {
  var dynamicImage = document.getElementById('dynamic-image');
  if(dynamicImage != null) {
    var defaultSrc = dynamicImage.src; // デフォルトの画像ソースを保存する

    // fadeIn/fadeOut効果で画像ソースを変更する関数
    function changeImageSource(newSrc) {
      dynamicImage.style.opacity = 1;
      setTimeout(function() {
        dynamicImage.src = newSrc;
        dynamicImage.style.opacity = 1;
      }, 0);
    }

    // 各リンクのhoverイベントを監視する
    document.querySelectorAll('.about-link').forEach(function(link) {
      link.addEventListener('mouseenter', function() {
        var newSrc = link.getAttribute('data-img-src');
        changeImageSource(newSrc);
      });
      link.addEventListener('mouseleave', function() {
        changeImageSource(defaultSrc);
      });
    });
  }
};
